'use strict';

function CampaignService(ipCookie, util, labelService, CAMPAIGN_COOKIE_EXPIRY) {
	var campaignId = null;

	function init() {
		var campaignIdFromCookie = ipCookie('sc_camp');
		var campaignIdFromQS = util.getQueryStringByName(window.location, 'sc_camp');

		// //expires: CAMPAIGN_COOKIE_EXPIRY, expirationUnit: 'milliseconds'
		campaignId = campaignIdFromQS ? campaignIdFromQS : campaignIdFromCookie;
		if (campaignIdFromQS)
			ipCookie('sc_camp', campaignIdFromQS, {});
	}

	function hasActiveCampaign() {
		return campaignId != null;
	}

	function getActiveCampaignId() {
		return campaignId;
	}

	function getCampaign() {
		if (!campaignId)
			return null;

		var campaign = labelService.extractCampaignInfoFor(campaignId);
		if (!campaign)
			console.error("No configuration for the active campaign '" + campaignId + "'");

		return campaign;
	}

	function getCampaignConfig(code, isCampaignNextStep) {
		var campaignText;

		if (isCampaignNextStep) {
			campaignText = util.isUndefinedOrNull(labelService.getGlobalOptionLabel('campaignConfiguration', code)) ?
				null : labelService.getGlobalOptionLabel('campaignConfiguration', code);
		} else {
			campaignText = util.isUndefinedOrNull(labelService.getGlobalOption('campaignBannerConfiguration', code)) ?
				null : labelService.getGlobalOption('campaignBannerConfiguration', code).bannerContent;
		}
		var campaignData = {
			isCampaignCodeValid: true,
			content: campaignText
		}

		if (util.isUndefinedOrNull(campaignText)) {
			campaignData.isCampaignCodeValid = false;
		}

		return campaignData;
	}

	return {
		init: init,
		hasActiveCampaign: hasActiveCampaign,
		getActiveCampaignId: getActiveCampaignId,
		getCampaign: getCampaign,
		getCampaignConfig: getCampaignConfig
	}
}
